<template>
  <section>
    <div
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      id="typhoon_map"
      class="typhoon_map_style"
    ></div>
  </section>
</template>

<script>
import L from '@/vendor/leaflet'
import '@/utils/bigscreen/leaflet.highlight.css'
import '@/utils/bigscreen/leaflet.highlight'
import typhoonMapTypes from '@/store/types/typhoonMap'
import config from '@/config'
let typhoonImg = require('@/assets/typhoon_map/images/typhoon.gif')

export default {
  props: {
    typemessage: Array
  },
  watch: {
    typemessage: function (value) {
      if (value.indexOf('台风路径') < 0) {
        this.loadTyphoon = false
      }
      if (value.indexOf('雷达图') < 0) {
        this.loadradar = false
      }
      if (value.indexOf('卫星云图') < 0) {
        this.loadCloud = false
      }
      if (value.indexOf('台风路径') !== -1) {
        if (!this.loadTyphoon) {
          this.loadTyphoon = true
          this.gettyphooninfo()
        }
      } else {
        var myGroup = L.layerGroup(this.layers)
        this.map.addLayer(myGroup)
        myGroup.clearLayers()
      }
      if (value.indexOf('雷达图') !== -1) {
        if (!this.loadradar) {
          this.loadradar = true
          this.drawDem()
        }
      } else {
        var radarGroup = L.layerGroup(this.Radarlarer)
        this.map.addLayer(radarGroup)
        radarGroup.clearLayers()
        // this.map.removeLayer(this.Radarlarer)
      }
      if (value.indexOf('卫星云图') !== -1) {
        if (!this.loadCloud) {
          this.loadCloud = true
          this.drawCloudPic()
        }
      } else {
        var cloudGroup = L.layerGroup(this.Cloudlarer)
        this.map.addLayer(cloudGroup)
        cloudGroup.clearLayers()
        // this.map.removeLayer(this.Cloudlarer)
      }
    }
  },
  data () {
    return {
      tfarray: [],
      loading: true,
      loading2: true,
      tfid: '',
      typhoonTestData: [],
      tfqvalue1: '',
      map: '',
      Cloudlarer: [],
      Radarlarer: [],
      layers: [],
      // cloudurl: '',
      // radarurl: ''
      loadTyphoon: false, // 是否加载台风
      loadradar: false, // 是否加载雷达图
      loadCloud: false // 是否加载卫星云图
    }
  },
  methods: {
    initMap () {
      // let vm = this
      let map = L.tianDiTuMap('typhoon_map', {
        zoomControl: false,
        maxZoom: 18,
        minZoom: 4,
        mapType: 1
      }).setView([25.991, 137.8], 5)
      this.map = map
      let linestr24 = [
        [0, 105],
        [4.5, 113],
        [11, 119],
        [18, 119],
        [22, 127],
        [30, 127],
        [34, 127]
      ]
      let linestr48 = [
        [0, 105],
        [0, 120],
        [15, 132],
        [30, 132],
        [34, 132]
      ]
      let myIcon24 = L.icon({
        iconUrl: require('@/assets/typhoon_map/images/hour24.png'),
        iconSize: [15, 80]
      })
      let myIcon48 = L.icon({
        iconUrl: require('@/assets/typhoon_map/images/hour48.png'),
        iconSize: [15, 80]
      })
      // 24小时警戒线
      L.polyline(linestr24, { color: '#BFBF04', weight: 2 }).addTo(map)
      // 48小时警戒线
      L.polyline(linestr48, { color: '#627BFF', weight: 2 }).addTo(map)
      let marker24 = L.marker([26, 127], { icon: myIcon24 })
      let marker48 = L.marker([26, 132], { icon: myIcon48 })
      marker24.addTo(map)
      marker48.addTo(map)
      map.on('zoomend', function () {
        let zoomVal = map.getZoom()
        if (zoomVal < 5) {
          marker24.remove()
          marker48.remove()
        } else {
          marker24.remove()
          marker48.remove()
          marker24.addTo(map)
          marker48.addTo(map)
        }
      })
    },
    // 获取台风信息
    gettyphooninfo () {
      this.loading = true
      let _this = this
      this.$store.dispatch(typhoonMapTypes.GET_TYPHOON_ACTIVITY, { tfid: _this.tfid }).then(data => {
        if (this.tfid === '') {
          this.tfarray = data[0]
        }
        if (data.length !== 0) {
          // let tfinfo = data[0]
          _this.loading2 = false
          data.forEach(item => {
            _this.tfid = item.tfid
            _this.loading = false
            _this.getTyphoonInfo1(item)
          })
          // _this.tfid = _this.tfarray.tfid
          // _this.loading = false
          // _this.getTyphoonInfo1(_this.tfarray)
        } else {
          _this.loading2 = false
          _this.drawTyphoonRouter()
        }
        this.loading = false
      })
    },
    getTyphoonInfo1 (tfinfo) {
      this.$store.dispatch(typhoonMapTypes.GET_TYPHOON_INFO, {
        tfid: this.tfid
      }).then(data => {
        this.typhoonTestData = data[0]
        this.tfqvalue1 = this.typhoonTestData.starttime
        // console.log(tfinfo, this.typhoonTestData, 'this.typhoonTestData')
        this.drawTyphoonRouter(tfinfo, this.typhoonTestData)
        this.coumputedForecastRoute(this.typhoonTestData) // 绘制预测路线
        this.loading = false
      })
    },
    // 处理预测路线数据
    coumputedForecastRoute (typhoonInfo) {
      let _this = this
      let allLinePointArr = [
        {
          area: '中国',
          pointArr: [],
          linePointArr: []
        },
        {
          area: '中国香港',
          pointArr: [],
          linePointArr: []
        },
        {
          area: '中国台湾',
          pointArr: [],
          linePointArr: []
        },
        {
          area: '美国',
          pointArr: [],
          linePointArr: []
        },
        {
          area: '日本',
          pointArr: [],
          linePointArr: []
        }
      ]
      let lastPoint = typhoonInfo.points.length - 1
      typhoonInfo.points[lastPoint].forecast.forEach((item, index) => {
        let area = item.tm
        item.forecastpoints.forEach((el, i) => {
          let tempLatLngArr = []
          let tempLat = []
          let tempLng = []
          tempLat = el.lat
          tempLng = el.lng
          tempLatLngArr.push(tempLat, tempLng)
          switch (area) {
            case '中国':
              allLinePointArr[0].linePointArr.push(tempLatLngArr)
              allLinePointArr[0].pointArr.push(el)
              break
            case '中国香港':
              allLinePointArr[1].linePointArr.push(tempLatLngArr)
              allLinePointArr[1].pointArr.push(el)
              break
            case '中国台湾':
              allLinePointArr[2].linePointArr.push(tempLatLngArr)
              allLinePointArr[2].pointArr.push(el)
              break
            case '美国':
              allLinePointArr[3].linePointArr.push(tempLatLngArr)
              allLinePointArr[3].pointArr.push(el)
              break
            case '日本':
              allLinePointArr[4].linePointArr.push(tempLatLngArr)
              allLinePointArr[4].pointArr.push(el)
              break
            default:
              break
          }
        })
      })

      allLinePointArr.forEach(item => {
        _this.drawForecastLine(item.linePointArr, item.area)
        _this.drawForecastPoint(item.pointArr, item.area)
      })
    },
    // 绘制预测点
    drawForecastPoint (pointData, area) {
      let map = this.map
      pointData.forEach((item, index) => {
        let myIcon1 = L.icon({
          iconUrl: require('@/assets/typhoon_map/images/marker1.png'),
          iconSize: [10, 10]
        })
        let myIcon2 = L.icon({
          iconUrl: require('@/assets/typhoon_map/images/marker2.png'),
          iconSize: [10, 10]
        })
        let myIcon3 = L.icon({
          iconUrl: require('@/assets/typhoon_map/images/marker3.png'),
          iconSize: [10, 10]
        })
        let myIcon4 = L.icon({
          iconUrl: require('@/assets/typhoon_map/images/marker4.png'),
          iconSize: [10, 10]
        })
        let myIcon5 = L.icon({
          iconUrl: require('@/assets/typhoon_map/images/marker5.png'),
          iconSize: [10, 10]
        })
        let myIcon6 = L.icon({
          iconUrl: require('@/assets/typhoon_map/images/marker6.png'),
          iconSize: [10, 10]
        })
        let myIcon = myIcon1
        let points = [Number(item['lat']), Number(item['lng'])]
        let powerValue = item.power
        if (powerValue > 5 && powerValue <= 7) {
          // 热带低压6-7
          myIcon = myIcon1
        } else if (powerValue > 7 && powerValue <= 9) {
          // 热带风暴8-9
          myIcon = myIcon2
        } else if (powerValue > 9 && powerValue <= 11) {
          // 强热带风暴10-11
          myIcon = myIcon3
        } else if (powerValue > 11 && powerValue <= 13) {
          // 台风12-13
          myIcon = myIcon4
        } else if (powerValue > 13 && powerValue <= 15) {
          // 强台风14-15
          myIcon = myIcon5
        } else if (powerValue >= 16) {
          // 超强台风>=16
          myIcon = myIcon6
        }
        let markers = L.marker(points, { icon: myIcon }).bindTooltip(
          '<div class="typhoonName"><h3>' +
            area +
            '</h3>' +
            '<span class="time">' +
            item.time +
            ' 预报' +
            '</span>' +
            '</div>' +
            '<div id="tab">' +
            '<ul class="tab">' +
            '<li class="tab_nav on">' +
            '<div class="tabcontnet">' +
            '<div class="contentname"><span>当前位置:</span></div>' +
            '<div class="contentnum"><span>' +
            item.lng +
            '°' +
            '/' +
            item.lat +
            '°' +
            '</span></div>' +
            '</div>' +
            '<div class="tabcontnet">' +
            '<div class="contentname"><span>中心气压:</span></div>' +
            '<div class="contentnum"><span>' +
            item.pressure +
            ' 百帕' +
            '</span></div>' +
            '</div>' +
            '<div class="tabcontnet">' +
            '<div class="contentname"><span>最大风速:</span></div>' +
            '<div class="contentnum"><span>' +
            item.speed +
            ' 米/秒' +
            '</span></div>' +
            '</div>' +
            '<div class="tabcontnet">' +
            '<div class="contentname"><span>风力:</span></div>' +
            '<div class="contentnum"><span>' +
            item.power +
            '级' +
            '</span></div>' +
            '</div>' +
            '</li>' +
            '</ul>' +
            '</div>',
          {
            parmanent: true,
            direction: 'top',
            sticky: true,
            className: 'animate-tooltip'
          }
        )
        markers.addTo(map)
        this.layers.push(markers)
      })
    },
    // 绘制预测虚线
    // L.polyline(linestr24, { color: '#BFBF04', weight: 2, dashArray: '5' }).addTo(map) // 虚线
    drawForecastLine (lineData, area) {
      let map = this.map
      let color = '#000000'
      switch (area) {
        case '中国':
          color = '#FF3C4E'
          break
        case '中国香港':
          color = '#FEBD00'
          break
        case '中国台湾':
          color = '#FF00FE'
          break
        case '美国':
          color = '#04FAF7'
          break
        case '日本':
          color = '#24BC00'
          break
        default:
          break
      }
      let yuceline = L.polyline(lineData, {
        color: color,
        weight: 1,
        dashArray: '5'
      }).addTo(map)
      this.layers.push(yuceline)
    },
    // 绘制台风路径
    drawTyphoonRouter (typhoonData, typhoonTestData) {
      let map = this.map
      //  数据转换
      if (typhoonData) {
        var allpoints = this.dataHandler(typhoonTestData, map)
        // var allNewPoints = this.pointHandler(typhoonTestData)
        // 根据坐标点数组polylinePoints通过 L.polyline 方法 绘制折线，颜色为蓝色#0a7ccd
        var polyline = L.polyline(allpoints, { color: '#0a7ccd' }).addTo(map)
        // polyline.snakeIn()
        map.removeLayer(polyline)
        // line
        var lineLayer
        // Marker
        var marker
        // icon
        var typhoonIcon = L.icon({
          iconUrl: typhoonImg,
          iconSize: [40, 40]
        })
        // this.animateDrawLine(lineLayer, marker, allpoints, typhoonIcon, map, typhoonData, typhoonTestData)
        /* 动态绘制折线 */
        this.animateDrawLine(
          lineLayer,
          marker,
          allpoints,
          typhoonIcon,
          map,
          typhoonData,
          typhoonTestData
        )
      }
      this.loading3 = false
    },
    // 绘制路径
    animateDrawLine (
      lineLayer,
      marker,
      allpoints,
      typhoonIcon,
      map,
      typhoonData,
      typhoonTestData
    ) {
      // allpoints 是上边介绍的数据转换的结果
      var allpoinstLength = allpoints.length
      // 定义用来存放递增元素的经纬度数据
      var drawPoints = []
      var count = 0
      // 定时器100ms，动态的塞入坐标数据
      this.timer = setInterval(() => {
        if (count < allpoinstLength) {
          drawPoints.push(allpoints[count])
          count++
          // 清除之前绘制的折线图层
          if (lineLayer && count !== allpoinstLength) {
            map.removeLayer(lineLayer)
            lineLayer = null
          }
          // 清除marker图层
          if (marker && count !== allpoinstLength) {
            map.removeLayer(marker)
            marker = null
          }
          // 最新数据点drawPoints绘制折线
          lineLayer = L.polyline(drawPoints, {
            color: '#0a7ccd',
            weight: 1
          }).addTo(map)
          this.layers.push(lineLayer)
          // 根据最新数组最后一个点绘制marker
          if (count === allpoinstLength) {
            map.removeLayer(marker)
            // 如果是台风最后一个点，则自动popup弹窗
            marker = L.marker(drawPoints[allpoinstLength - 1], {
              icon: typhoonIcon
            })
              .addTo(map)
              .bindPopup(
                '<b>' +
                  typhoonData['name'] +
                  '(' +
                  typhoonData['timeformate'] +
                  ')'
              )
              .openPopup()
            this.layers.push(marker)
          } else {
            marker = L.marker(drawPoints[count - 1], {
              icon: typhoonIcon
            }).addTo(map)
            this.layers.push(marker)
          }
        }
      }, 100)
    },
    /* 数据转换 & 绘制折线图 */
    dataHandler (typhoonTestData, map) {
      // 获取台风坐标点数据对象
      var forecast = typhoonTestData['points']
      // 定义折线点数据
      var polylinePoints = []
      // 循环拼接数据[[经度，纬度],[经度,纬度]] 的格式
      var myIcon1 = L.icon({
        iconUrl: require('@/assets/typhoon_map/images/marker1.png'),
        iconSize: [10, 10]
      })
      var myIcon2 = L.icon({
        iconUrl: require('@/assets/typhoon_map/images/marker2.png'),
        iconSize: [10, 10]
      })
      var myIcon3 = L.icon({
        iconUrl: require('@/assets/typhoon_map/images/marker3.png'),
        iconSize: [10, 10]
      })
      var myIcon4 = L.icon({
        iconUrl: require('@/assets/typhoon_map/images/marker4.png'),
        iconSize: [10, 10]
      })
      var myIcon5 = L.icon({
        iconUrl: require('@/assets/typhoon_map/images/marker5.png'),
        iconSize: [10, 10]
      })
      var myIcon6 = L.icon({
        iconUrl: require('@/assets/typhoon_map/images/marker6.png'),
        iconSize: [10, 10]
      })
      var myIcon = myIcon1
      for (var i = 0; i < forecast.length; i++) {
        var p = forecast[i]
        polylinePoints.push([Number(p['lat']), Number(p['lng'])])
      }
      forecast.forEach(item => {
        var sevenRadius = item.radius7.split('|')
        var tenRadius = item.radius10.split('|')
        var twelveRadius = item.radius12.split('|')
        sevenRadius.forEach((item, index) => {
          sevenRadius[index] = Number(item)
        })
        tenRadius.forEach((item, index) => {
          tenRadius[index] = Number(item)
        })
        twelveRadius.forEach((item, index) => {
          twelveRadius[index] = Number(item)
        })
        sevenRadius = sevenRadius.sort()
        tenRadius = tenRadius.sort()
        twelveRadius = twelveRadius.sort()
        if (sevenRadius[0] === sevenRadius[sevenRadius.length - 1]) {
          sevenRadius = sevenRadius.splice(0, 1)
        } else if (sevenRadius[0] > sevenRadius[sevenRadius.length - 1]) {
          let temp1 = sevenRadius[0]
          let temp2 = sevenRadius[sevenRadius.length - 1]
          sevenRadius[0] = temp2
          sevenRadius[sevenRadius.length - 1] = temp1
        }
        if (tenRadius[0] === tenRadius[tenRadius.length - 1]) {
          tenRadius = tenRadius.splice(0, 1)
        } else if (tenRadius[0] > tenRadius[tenRadius.length - 1]) {
          let temp1 = tenRadius[0]
          let temp2 = tenRadius[tenRadius.length - 1]
          tenRadius[0] = temp2
          tenRadius[tenRadius.length - 1] = temp1
        }
        if (twelveRadius[0] === twelveRadius[twelveRadius.length - 1]) {
          twelveRadius = twelveRadius.splice(0, 1)
        } else if (twelveRadius[0] > twelveRadius[twelveRadius.length - 1]) {
          let temp1 = twelveRadius[0]
          let temp2 = twelveRadius[twelveRadius.length - 1]
          twelveRadius[0] = temp2
          twelveRadius[twelveRadius.length - 1] = temp1
        }
        let points = [Number(item['lat']), Number(item['lng'])]
        let powerValue = item.power
        if (powerValue > 5 && powerValue <= 7) {
          // 热带低压6-7
          myIcon = myIcon1
        } else if (powerValue > 7 && powerValue <= 9) {
          // 热带风暴8-9
          myIcon = myIcon2
        } else if (powerValue > 9 && powerValue <= 11) {
          // 强热带风暴10-11
          myIcon = myIcon3
        } else if (powerValue > 11 && powerValue <= 13) {
          // 台风12-13
          myIcon = myIcon4
        } else if (powerValue > 13 && powerValue <= 15) {
          // 强台风14-15
          myIcon = myIcon5
        } else if (powerValue >= 16) {
          // 超强台风>=16
          myIcon = myIcon6
        }
        let marker = L.marker(points, { icon: myIcon })
          .addTo(map)
          .bindTooltip(
            '<div class="typhoonName"><h3>' +
              typhoonTestData.name +
              '</h3>' +
              '<span class="time">' +
              item.time +
              '</span>' +
              '</div>' +
              '<div id="tab">' +
              '<ul class="tab">' +
              '<li class="tab_nav on">' +
              '<div class="tabcontnet">' +
              '<div class="contentname"><span>中心位置:</span></div>' +
              '<div class="contentnum"><span>' +
              item.lng +
              '°' +
              '/' +
              item.lat +
              '°' +
              '</span></div>' +
              '</div>' +
              '<div class="tabcontnet">' +
              '<div class="contentname"><span>风速风力:</span></div>' +
              '<div class="contentnum"><span>' +
              item.speed +
              ' 米/秒,' +
              '</span>' +
              '<span style="color:red">' +
              item.power +
              '级' +
              '(' +
              item.strong +
              ')' +
              '</span>' +
              '</div>' +
              '</div>' +
              '<div class="tabcontnet">' +
              '<div class="contentname"><span>中心气压:</span></div>' +
              '<div class="contentnum"><span>' +
              item.pressure +
              ' 百帕' +
              '</span></div>' +
              '</div>' +
              '<div class="tabcontnet">' +
              '<div class="contentname"><span>移速移向:</span></div>' +
              '<div class="contentnum"><span>' +
              item.movespeed +
              ' 公里/小时,' +
              item.movedirection +
              '</span></div>' +
              '</div>' +
              '<div class="tabcontnet' +
              (sevenRadius[0] === 0 || sevenRadius.length < 2
                ? ' hidden_img'
                : '') +
              '">' +
              '<div class="contentname"><span>七级半径:</span></div>' +
              '<div class="contentnum"><span>' +
              sevenRadius[0] +
              '~' +
              sevenRadius[sevenRadius.length - 1] +
              ' 公里' +
              '</span></div>' +
              '</div>' +
              '<div class="tabcontnet' +
              (sevenRadius[0] !== 0 && sevenRadius.length < 2
                ? ''
                : ' hidden_img') +
              '">' +
              '<div class="contentname"><span>七级半径:</span></div>' +
              '<div class="contentnum"><span>' +
              sevenRadius[0] +
              ' 公里' +
              '</span></div>' +
              '</div>' +
              '<div class="tabcontnet' +
              (tenRadius[0] === 0 || tenRadius.length < 2
                ? ' hidden_img'
                : '') +
              '">' +
              '<div class="contentname"><span>十级半径:</span></div>' +
              '<div class="contentnum"><span>' +
              tenRadius[0] +
              '~' +
              tenRadius[tenRadius.length - 1] +
              ' 公里' +
              '</span></div>' +
              '</div>' +
              '<div class="tabcontnet' +
              (tenRadius[0] !== 0 && tenRadius.length < 2
                ? ''
                : ' hidden_img') +
              '">' +
              '<div class="contentname"><span>十级半径:</span></div>' +
              '<div class="contentnum"><span>' +
              tenRadius[0] +
              ' 公里' +
              '</span></div>' +
              '</div>' +
              '<div class="tabcontnet' +
              (twelveRadius[0] === 0 || twelveRadius.length < 2
                ? ' hidden_img'
                : '') +
              '">' +
              '<div class="contentname"><span>十二级半径:</span></div>' +
              '<div class="contentnum"><span>' +
              twelveRadius[0] +
              '~' +
              twelveRadius[twelveRadius.length - 1] +
              ' 公里' +
              '</span></div>' +
              '</div>' +
              '<div class="tabcontnet' +
              (twelveRadius[0] !== 0 && twelveRadius.length < 2
                ? ''
                : ' hidden_img') +
              '">' +
              '<div class="contentname"><span>十二级半径:</span></div>' +
              '<div class="contentnum"><span>' +
              twelveRadius[0] +
              ' 公里' +
              '</span></div>' +
              '</div>' +
              '</li>' +
              '</ul>' +
              '</div>',
            {
              parmanent: true,
              direction: 'top',
              sticky: true,
              className: 'animate-tooltip'
            }
          )
        this.layers.push(marker)
      })
      return polylinePoints
    },
    /* 数据转换 & 绘制点 */
    pointHandler (typhoonTestData) {
      // 获取台风坐标点数据对象
      var forecast = typhoonTestData['points']
      // 定义折线点数据
      var polylinePoints = []
      var polylinePointsObj = []
      var polylinePointsPower = []
      // 循环拼接数据[[经度，纬度],[经度,纬度]] 的格式
      for (var i = 0; i < forecast.length; i++) {
        var p = forecast[i]
        polylinePoints.push([Number(p['lat']), Number(p['lng'])])
        polylinePointsObj.latlng = [Number(p['lat']), Number(p['lng'])]
        polylinePointsObj.power = p.power
        polylinePointsPower.push(polylinePointsObj)
      }
      return polylinePointsPower
    },
    // 雷达图绘制
    drawDem () {
      this.loading = true
      var bounds = [
        [36.857889133070225, 112.5],
        [22.20304553343818, 123.75]
      ] // new L.LatLngBounds(southWest, northEast)
      // let radarurl
      this.$store.dispatch(typhoonMapTypes.GET_WEATHER_RADAR).then(data => {
        let arr = data.ZJ
        let radarurl = arr[arr.length - 1]
        this.loading = false
        let url = 'http://www.zjsq.net.cn:8010' + radarurl
        let demarr = L.imageOverlay(url, bounds, {
          maxZoom: 16,
          opacity: 1
        }).addTo(this.map)
        this.Radarlarer.push(demarr)
      })
    },
    // 卫星云图绘制
    drawCloudPic () {
      this.loading = true
      var bounds = [
        [45.0, 95.0],
        [0.0, 160.0]
      ] // new L.LatLngBounds(southWest, northEast)
      // let Cloudlarer
      this.$store.dispatch(typhoonMapTypes.GET_CLOUD_PIC, { num: '1' }).then(data => {
        let cloudurl = data.rows[0].picUrl
        this.loading = false
        let clouddem = L.imageOverlay(
          config.ApiYJ + '/' + cloudurl,
          bounds,
          {
            maxZoom: 16,
            opacity: 1
          }
        ).addTo(this.map)
        this.Cloudlarer.push(clouddem)
      })
    }
  },
  mounted () {
    // this.getradar()
    // this.getcloudpic()
    this.$nextTick(_ => {
      this.initMap()
      if (this.typemessage.indexOf('台风路径') !== -1) {
        if (!this.loadTyphoon) {
          this.loadTyphoon = true
          this.gettyphooninfo()
        }
      } else if (this.typemessage.indexOf('雷达图') !== -1) {
        if (!this.loadradar) {
          this.loadradar = true
          this.drawDem()
        }
      } else if (this.typemessage.indexOf('卫星云图') !== -1) {
        if (!this.loadCloud) {
          this.loadCloud = true
          this.drawCloudPic()
        }
      }
    })
    this.timer = setInterval(() => {
      if (this.map) {
        this.map.remove()
      }
      this.initMap()
      if (this.typemessage.indexOf('台风路径') !== -1) {
        this.gettyphooninfo()
      }
      if (this.typemessage.indexOf('雷达图') !== -1) {
        this.drawDem()
      }
      if (this.typemessage.indexOf('卫星云图') !== -1) {
        this.drawCloudPic()
      }
    }, 60 * 1000 * 5)
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer) // 在Vue实例销毁前，清除我们的定时器
    }
  }
}
</script>

<style lang='less'>
#typhoon_map {
  position: absolute;
  top:0;
  left:0;
  width: 100%;
  height: 1080px;
  /deep/ .animate-tooltip {
    width: 350px;
    padding: 1px;
    .hidden_img {
      display: none !important;
    }
    .typhoonName {
      background: #0099cc;
      color: #ffffff;
      h3 {
        width: 30%;
        margin: 5px auto;
        display: inline-block;
        text-align: center;
      }
      .time {
        width: 65%;
        display: inline-block;
      }
    }
    #tab {
      position: relative;
      width: 90%;
      margin: 0 auto;
      .tab {
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0 auto;
        .tabcontnet {
          width: 1005;
          height: 35px;
          font-size: 15px;
          line-height: 35px;
          border-bottom: 1px solid #ccc;
          .contentname {
            width: 40%;
            display: inline-block;
            color: #ccc;
          }
          .contentnum {
            width: 60%;
            display: inline-block;
          }
        }
      }
      li {
        list-style: none;
      }
      .tab_nav {
        width: 100%;
        max-height: 320px;
        overflow: auto;
      }
    }
  }
}
</style>
